import { useEffect, useState } from "react";

const INITIAL_DELAY = 200;

export const useVisibilityTransition = (active: boolean, delay: number = INITIAL_DELAY) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    let timeoutId: number;

    if (active && !shouldRender) {
      setShouldRender(true);
    } else if (!active && shouldRender) {
      timeoutId = window.setTimeout(() => setShouldRender(false), delay);
    }

    return () => clearTimeout(timeoutId);
  }, [active, shouldRender]);

  return shouldRender;
};
